import { axiosInstance } from '@applyboard/ui-utils';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

export type IRoutesInfo = {
  [key: string]: string;
};
const useRoutes = (defaultUrl: string = '/configs/routes.json'): IRoutesInfo | null => {
  const [routes, setRoutes] = useState(null);
  const myLocation = useLocation();

  const url = useMemo<string>(
    () =>
      [
        // @ts-ignore
        window.SPA_PATH,
        defaultUrl,
      ]
        .filter(Boolean)
        .join('/')
        .replace(/\/+/g, '/'),
    [myLocation?.pathname, defaultUrl],
  );

  useEffect(() => {
    let cancelled = false;
    setRoutes(null);
    axiosInstance.get<IRoutesInfo>(url).then(resp => {
      if (cancelled) return null;
      setRoutes(resp.data);
      return resp;
    });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return routes;
};

export default useRoutes;
